"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsABAValidator = void 0;
exports.isABA = isABA;
const class_validator_1 = require("class-validator");
let IsABAValidator = class IsABAValidator {
    validate(rawABA) {
        return isABA(rawABA);
    }
    defaultMessage() {
        return "ABA is in wrong format.";
    }
};
exports.IsABAValidator = IsABAValidator;
exports.IsABAValidator = IsABAValidator = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "is ABA" })
], IsABAValidator);
function isABA(rawABA) {
    if (!rawABA) {
        return false;
    }
    const len = rawABA.trim().length;
    const isCorrectLength = len === 9;
    const areAllDigits = /^[0-9]{9}$/.test(rawABA.trim());
    return isCorrectLength && areAllDigits;
}
//# sourceMappingURL=IsABAValidator.js.map